import React from 'react';
import { AuthProvider } from './auth/AuthProvider';
import { AppRouter } from './routers/AppRouter';

import './assets/css/site.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';

export const App = () => {
    
	return (
        <>
            <AuthProvider>
                <AppRouter />
            </AuthProvider>
        </>
    )
}